import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const ItemContainer = styled.div`
  border-radius: ${props => props.theme.primitives.radius.radius3};
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.theme.colors.background.secondary};
  padding: ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius3};
`

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp8} 12px;
`

export const DetailLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
